<template>
    <div>
        <v-toolbar app flat dark color="primary">
            <v-btn icon @click="gotoOverview()">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Berichten</v-toolbar-title>
            <v-btn icon></v-btn>
        </v-toolbar>

        <v-content class="uf-form" fill-height>
            <v-card>
                <template>
                    <v-list two-line>
                        <template v-for="(item, $index) in notifications">
                            <v-list-tile
								:key="$index"
								:data-num="$index + 1"
								avatar
								:class="[ !item.opened_at ? 'new-notification' : '', 'notification-item']"
								@click="gotoNotificationDetails(item.id)">

                                <v-list-tile-content class="notification-content">
                                    <v-list-tile-title>
                                        {{ item.title }}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item.text }}</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action class="notification-action">
                                    <v-list-tile-action-text>
										{{ item.sent_at }}
									</v-list-tile-action-text>
                                </v-list-tile-action>
                                <v-icon>chevron_right</v-icon>
                            </v-list-tile>
                            <v-divider></v-divider>
                        </template>
                    </v-list>
                    <infinite-loading @infinite="infiniteHandler" spinner="spiral">
                        <template slot="no-more">Geen berichten meer</template>
                        <template slot="no-results">Geen berichten</template>
                        <template slot="error" slot-scope="{ trigger }">
                            Kan geen bericten laden, <a href="javascript:;" @click="trigger">probeer opnieuw</a>
                        </template>
                    </infinite-loading>
                </template>
<!--                <v-container v-else fluid fill-height>-->
<!--                    <v-layout align-center justify-center>-->
<!--                        <v-flex xs12 sm8 md4>-->
<!--                            <v-card flat>-->
<!--                                <v-card-text text-center>U heeft geen nieuwe notificaties</v-card-text>-->
<!--                            </v-card>-->
<!--                        </v-flex>-->
<!--                    </v-layout>-->
<!--                </v-container>-->
            </v-card>
        </v-content>

    </div>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';
    import {mapGetters} from "vuex";
    import notifications from "../../store/modules/notifications";

    export default {
        components: {
            InfiniteLoading,
        },
        computed: {
            ...mapGetters(['notifications', 'currentPage', 'lastPage']),
        },
        methods: {
            gotoOverview() {
                this.$router.go(-1);
            },
            infiniteHandler($state) {
                this.loadNotifications($state, this.currentPage + 1);
            },
            gotoNotificationDetails(id){
                this.$store.dispatch('openNotification', id).then(() => {
                    this.$router.push(`/notifications/${id}`);
                });
            },
            loadNotifications($state, page = 1) {
                let count = this.notifications.length;
                this.$store.dispatch('loadNotifications', page).then(() => {
                    if(this.notifications.length > count) {
                        $state.loaded();
                    }
                    else {
                        $state.complete();
                    }
                });
            }
        },
        destroyed() {
            this.$store.dispatch('resetNotifications');
        },
    }
</script>

<style scoped lang="stylus">
    .notification-content
        width: 70%
        padding-left: 4px
        padding-right: 10px

    .notification-action
        width: 20%

    .notification-item
        position: relative

    .notification-item.new-notification:before
        content: ''
        position: absolute
        display: block
        top: 25%
        left: 1%
        background-color: #F18E00
        width: 10px
        height: 10px
        border-radius: 50%

</style>
